// (C) Copyright 2020 MediaWink, LLC

export const selectHtml = (state) => state.html;
